// extracted by css-extract-rspack-plugin
export default {"body":"TableBody_body__yzXH2"};